import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getNotification } from '@sportninja/common/services/notifications/notificationService'
import { getApiErrorMessage } from '@sportninja/common/features/notifications/utils/apiErrorMessage'
import type { LandingNotification } from '@sportninja/common/features/notifications/types/landing'

/**
 * GET /notifications/:id for the detail page. staleTime is 0 because the
 * notification's read/action state changes as the user acts on it.
 */
export const useNotification = (notificationId?: string) => {
  const query = useQuery<LandingNotification>({
    queryKey: queryKeys.notification.byId(notificationId ?? ''),
    queryFn: () => getNotification(notificationId as string),
    enabled: Boolean(notificationId),
    staleTime: 0,
    retry: false,
  })

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    // The API's own message (e.g. "The requested resource could not be
    // found."), so the error card can show why rather than generic copy.
    errorMessage: getApiErrorMessage(query.error),
  }
}
